import request from './request'

// get 请求
export const proModuleApi = {
  // 获取首页轮播图
  getbanner: query => {
    return request({
      url: 'banner/' + query,
      method: 'get'
    })
  },
  // 获取分类
  getCategory: query => {
    return request({
      url: 'category/all',
      method: 'get'
    })
  },
  // 获取热门
  getHotClassify: query => {
    return request({
      url: 'product/hot',
      method: 'get'
    })
  },
  // 获取供应商
  getSupplier: query => {
    return request({
      url: 'supplier/all',
      method: 'get'
    })
  },
  // 获取省市区信息
  regionInfo: query => {
    return request({
      url: 'basic/region',
      method: 'get',
      data: query
    })
  },
  // 注册
  registerInfo: query => {
    return request({
      url: 'user/register',
      method: 'post',
      data: query
    })
  },
  // 登录
  loginInfo: query => {
    return request({
      url: 'user/login',
      method: 'post',
      data: query
    })
  },
  // 根据分类获取商品 粮油米面
  productClassify: (id, limit = 8) => {
    return request({
      url: `product/by_category/${id}/${limit}`,
      method: 'get'
    })
  },
  // 发布商品
  releasePro: query => {
    return request({
      url: 'product/release',
      method: 'post',
      data: query
    })
  },
  // 获取产品详情
  getProInfor: query => {
    return request({
      url: 'product/' + query,
      method: 'get'
      // data:query
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/home.js